import { ControlBarButton, ControlBarButtonProps, ControlBarButtonStrings, ControlBarButtonStyles } from "@azure/communication-react";
import React from "react";
import { SettingsFilled } from "@fluentui/react-icons";


interface ControlBarDeviceSettingsButtonProps extends ControlBarButtonProps{
    onClick: () => void;
    checked: boolean;
    styles?: ControlBarButtonStyles;
}

export const ControlBarDeviceSettingsButton = (props: ControlBarDeviceSettingsButtonProps) => {

    const SettingsIcon = () => <SettingsFilled fontSize={24} />;

    const strings: ControlBarButtonStrings = {
        tooltipOnContent: "Einstellungen",
        tooltipOffContent: "Einstellungen",
    }

    return (
        <ControlBarButton
            {...props}
            strings={strings}
            onRenderOnIcon={SettingsIcon}
            onRenderOffIcon={SettingsIcon}
            onClick={() => props.onClick()}
        />
    );
}
